import type {SavedSearch} from '@netx/core-search-saved/types';
import {mediaServicesAvailable} from '@netx/core-share-media-service/enablers';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {canShareWithTeam} from '@netx/core-team-access/enablers';
import {
	currentUserHasAccess,
	PermissionName,
	legacyPermissionsEnabled,
} from '@netx/core-permissions-next/enablers';

export const canCreateShareLinkFromSavedSearch = (
	savedSearch?: SavedSearch,
) => {
	if (savedSearch == null || !savedSearch.contentCount) return false;
	if (!currentUserMeetsUserLevel(UserLevel.CONSUMER)) return false;
	return currentUserHasAccess(PermissionName.CREATE_SHARE_LINKS);
};

export const canCreatePdfFromSavedSearch = (savedSearch?: SavedSearch) => {
	if (savedSearch == null || !savedSearch.contentCount) return false;
	if (!currentUserMeetsUserLevel(UserLevel.CONSUMER)) return false;
	return currentUserHasAccess(PermissionName.DOWNLOAD);
};

export const canSharePdfFromSavedSearch = (savedSearch?: SavedSearch) => {
	if (savedSearch == null || !savedSearch.contentCount) return false;
	if (!currentUserMeetsUserLevel(UserLevel.CONSUMER)) return false;
	return currentUserHasAccess(PermissionName.CREATE_SHARE_LINKS);
};

export const canDownloadSavedSearch = (savedSearch?: SavedSearch) => {
	if (!savedSearch || !savedSearch.contentCount) return false;
	if (!currentUserMeetsUserLevel(UserLevel.CONSUMER)) return false;
	return currentUserHasAccess(PermissionName.DOWNLOAD);
};

// TODO: this is incomplete at the moment... more, it is a holdover for react until we get the share menu
// reworked one day
export const canShareSavedSearch = (savedSearch?: SavedSearch) => {
	if (savedSearch == null || !savedSearch.contentCount) return false;

	if (legacyPermissionsEnabled()) {
		// it should be safe (atm) to assume that if this action is not available, then none of the other actions would be
		return (
			(currentUserMeetsUserLevel(UserLevel.DIRECTOR) &&
				mediaServicesAvailable()) ||
			// share:assetSet:token -> matrix: 'download',
			// share:assetSet:media:service -> [mediaServicesEnabled, downloadOptionSelected], matrix: 'download',
			// share:token:embed -> [canEmbed], matrix: 'download',
			currentUserMeetsUserLevel(UserLevel.CONSUMER)
		);
	}

	return currentUserHasAccess(PermissionName.CREATE_SHARE_LINKS);
};

export const canShareSavedSearchWithTeam = (savedSearch?: SavedSearch) => {
	if (!savedSearch) return false;
	return canShareWithTeam() && savedSearch.canManage;
};

export const canDeleteSavedSearch = (savedSearch?: SavedSearch) =>
	savedSearch?.canManage === true;

export const canRenameSavedSearch = (savedSearch?: SavedSearch) =>
	savedSearch?.canManage === true;
